<template>
  <div class="ticket-create-modal">
    <section class="header-container">
      <p class="section-label">
        {{ $t("ticket.ticket_history") }}
      </p>
      <!--      {{ roleStore.canUserCreateTicket !== -1 ? "can" : "can t" }}-->
      <template v-if="!roleStore.canUserCreateTicket">
        <FeatherIcon
          v-b-tooltip.hover
          :title="$t('ticket.create_ticket_required_access')"
          style="opacity: 0.3; cursor: not-allowed"
          class="clickable-icon"
          icon="PlusIcon"
          size="24"
        />
      </template>
      <template v-else>
        <FeatherIcon
          v-b-modal.create-form
          class="clickable-icon"
          icon="PlusIcon"
          size="24"
        />
      </template>
    </section>

    <section class="ticket-history">
      <template v-if="roleStore.canUserViewTicket">
        <ul style="padding-left: 1.5em">
          <li v-for="each in history" :key="each.id" class="title-history">
            <RouterLink
              :class="
                each.id === $router.currentRoute.query.id
                  ? 'active-selected-ticket'
                  : 'inactive-selected-ticket'
              "
              :to="`/ticket?id=${each.id}`"
            >
              {{ each.title }}
            </RouterLink>
          </li>
        </ul>
      </template>
      <template v-else>
        <div style="text-align: center; color: #b9b9c3; margin-top: 1.5em">
          <FeatherIcon icon="AlertCircleIcon" size="24" />
          <p class="no-access" style="padding: 0 2em">
            {{ $t("ticket.view_ticket_required_access") }}
          </p>
        </div>
      </template>
    </section>
    <b-modal
      id="create-form"
      centered
      size="lg"
      :title="$t('ticket.create_new_ticket')"
    >
      <!--        <b-form @submit.prevent="$emit('submit',{...createForm,internalNote})">-->
      <b-form @submit.stop.prevent="handleSubmitForm">
        <div class="h-stack">
          <b-form-group
            id="validate-title"
            :label="$t('ticket.ticket_title')"
            label-for="title"
          >
            <div
              style="width: 100%"
              :class="{ error: v$.title.$errors.length }"
            >
              <b-form-input
                id="title"
                v-model.trim="createForm.title"
                autocomplete="off"
                type="text"
                :placeholder="$t('ticket.please_enter_your_title')"
                @input="v$.title.$touch()"
                @blur="v$.title.$touch()"
              />

              <span v-for="error of v$.title.$errors" :key="error.$uid">
                <span style="color: #8d5185">
                  {{ error.$message }}
                </span>
              </span>
            </div>

            <!--            aria-describedby="validate-title-feedback"-->

            <!--            <b-form-invalid-feedback :state="titleValidation">-->
            <!--              {{ $t('ticket.this_field_is_required') }}-->
            <!--            </b-form-invalid-feedback>-->
            <!--            <b-form-valid-feedback :state="titleValidation">-->
            <!--              Looks Good.-->
            <!--            </b-form-valid-feedback>-->
          </b-form-group>
          <b-form-group :label="$t('ticket.priority')" label-for="priority">
            <b-form-select
              id="priority"
              v-model="createForm.priorityLevel"
              style="text-transform: uppercase"
              type="text"
              :options="translatePriority"
              required
            />
          </b-form-group>
        </div>
        <div class="h-stack">
          <b-form-group
            :label="$t('ticket.email')"
            label-for="email"
            :description="$t('ticket.email_input_notify')"
          >
            <!--            <b-form-input-->
            <!--              id="email"-->
            <!--              v-model.trim="createForm.customerEmail"-->
            <!--              type="email"-->
            <!--              :placeholder="$t('ticket.please_enter_your_email')"-->
            <!--              required-->
            <!--            />-->
            <b-form-input
              id="email"
              v-model.trim="email"
              :disabled="true"
              type="email"
              :placeholder="$t('ticket.please_enter_your_email')"
              required
            />
          </b-form-group>
          <b-form-group :label="$t('ticket.assignee')" label-for="assignee">
            <b-form-select
              id="assignee"
              v-model="createForm.operatorAssigned"
              type="text"
              :options="translateAssignee"
            />
          </b-form-group>
        </div>

        <b-form-group :label="$t('ticket.description')" label-for="description">
          <div
            style="width: 100%"
            :class="{ error: v$.ticketDescription.$errors.length }"
          >
            <b-form-textarea
              id="description"
              v-model="createForm.ticketDescription"
              :placeholder="$t('ticket.please_enter_your_description')"
              rows="4"
              max-rows="4"
              no-resize
              type="text"
              @input="v$.ticketDescription.$touch()"
              @blur="v$.ticketDescription.$touch()"
            />

            <span
              v-for="error of v$.ticketDescription.$errors"
              :key="error.$uid"
            >
              <span style="color: #8d5185">
                {{ error.$message }}
              </span>
            </span>
          </div>

          <!--          <b-form-invalid-feedback :state="descriptionValidation">-->
          <!--            {{ $t('ticket.this_field_is_required') }}-->
          <!--          </b-form-invalid-feedback>-->
        </b-form-group>

        <div class="mb-2">
          <b-form-checkbox v-model="internalNote" name="check-button" switch>
            {{ $t("ticket.internal_note") }}
          </b-form-checkbox>
        </div>

        <div style="text-align: end">
          <b-button
            type="submit"
            variant="primary"
            :disabled="loading || !titleValidation || !descriptionValidation"
          >
            <!--            {{ loading ? 'Please wait...' : 'Submit' }}-->
            {{
              ticketStore.loading.isSubmitting
                ? $t("general.loading")
                : $t("ticket.submit")
            }}
          </b-button>
        </div>
      </b-form>
      <template #modal-footer>
        <span />
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BModal,
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BToast,
  BTooltip,
  BFormInvalidFeedback,
  BFormValidFeedback,
} from "bootstrap-vue";
import {
  computed,
  nextTick,
  reactive,
  ref,
  watch,
  onMounted,
} from "@vue/composition-api";
import useTicketStore from "@/store-pinia/useTicketStore";
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, maxLength } from "@vuelidate/validators";

import { requiredValidate, maxValidate } from "@/libs/i18n/i18n-validator";
import useRoleStore from "@/store-pinia/useRoleStore";
import useJwt from "@/auth/jwt/useJwt";

export default {
  components: {
    BModal,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormTextarea,
    BToast,
    BTooltip,
    BFormInvalidFeedback,
    BFormValidFeedback,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    history: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Object,
      default: () => ({
        priority: [
          {
            value: null,
            text: "Please select an option",
          },
        ],
        assignee: [
          {
            value: null,
            text: "Please select an option",
          },
        ],
      }),
    },
    email: {
      type: String,
      default: "",
    },
    customerId: {
      type: String,
      default: "",
    },
    isPrivateChat: {
      type: Boolean,
      default: false,
    },
    roomId: {
      type: String,
      default: "",
    },
  },
  computed: {
    translateAssignee() {
      const { assignee } = this.options;
      return assignee.map((item) => {
        const { value, text } = item;
        return {
          value,
          text: this.$t(text),
        };
      });
    },
    translatePriority() {
      const { priority } = this.options;
      return priority.map((item) => {
        const { value, text } = item;
        return {
          value,
          text: this.$t(text),
        };
      });
    },
  },
  setup(props, { emit }) {
    const roleStore = useRoleStore();
    const ticketStore = useTicketStore();
    const internalNote = ref(false);
    const createForm = reactive({
      title: "",
      operatorAssigned: "",
      priorityLevel: "1",
      ticketDescription: "",
      // customerEmail: '',
    });

    const rules = {
      // title: { required, maxLength: maxLength(50) },
      // ticketDescription: { required, maxLength: maxLength(5000) },
      title: { requiredValidate, maxLength: maxValidate(50) },
      ticketDescription: { requiredValidate, maxLength: maxValidate(5000) },
    };

    const v$ = useVuelidate(rules, createForm);

    watch(
      () => props.roomId,
      (newValue, oldValue) => {
        if (newValue && props.isPrivateChat) {
          ticketStore.getChatMeRoomInfo(newValue, userData.value.id);
        }
      }
    );

    onMounted(() => {
      if (props.isPrivateChat && props.roomId) {
        ticketStore.getChatMeRoomInfo(props.roomId, userData.value.id);
      }
    });

    function resetForm() {
      internalNote.value = false;
      createForm.title = "";
      createForm.operatorAssigned = "";
      createForm.priorityLevel = "1";
      createForm.ticketDescription = "";
      createForm.roomId = "";
      // createForm.customerEmail = ''
    }

    const titleValidation = computed(() => createForm.title.length > 0);

    const userData = computed(() => {
      const storedData = localStorage.getItem(
        useJwt.jwtConfig.storageUserDataKeyName
      );
      return storedData ? JSON.parse(storedData) : null;
    });

    const descriptionValidation = computed(
      () => createForm.ticketDescription.length > 0
    );

    async function handleSubmitForm() {
      const submitForm = {
        ...createForm,
        customerEmail: props.email,
        internalNote: internalNote.value ? 1 : 0,
        isPrivateChat: props.isPrivateChat,
        roomId: props.roomId,
      };

      const result = await ticketStore.createTicketAsync(
        submitForm,
        props.customerId
      );

      if (result) {
        this.$bvModal.hide("create-form");
        resetForm();
        emit("submit-respond", true);
      } else {
        emit("submit-respond", false);
      }
    }

    return {
      userData,
      ticketStore,
      createForm,
      internalNote,
      roleStore,

      resetForm,
      handleSubmitForm,
      titleValidation,
      descriptionValidation,
      v$,
    };
  },
};
</script>

<style lang="scss" scoped>
.ticket-create-modal {
  // padding-bottom: 1em;

  .header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header-subtitle {
    font-size: 0.85em;
    color: gray;
  }

  .clickable-icon {
    cursor: pointer;
  }
}

.h-stack {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

.ticket-history {
  overflow: auto;
  max-height: 300px;
}

.title-history {
  font-weight: 500;
  margin-bottom: 0.3rem;
}

.ticket-history-list {
  padding: 0.15em 0.5em;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  width: fit-content;
}

.active-selected-ticket {
  @extend .ticket-history-list;
  background: #9f6096;
  color: whitesmoke;
  border-radius: 10px;
}

.inactive-selected-ticket {
  @extend .ticket-history-list;
  color: #9f6096;

  &:hover {
    background: #f2f0f7;
    border-radius: 10px;

    transition: 0.3s;
  }
}
</style>
